import * as THREE from "three";

// Aerial-perspective haze: replaces three's uniform FogExp2 shading with a
// height-aware, distance-tinted version by overriding the global fog shader
// chunks (one patch, applies to every fogged material). Valley floors sink
// into warm haze while ridgelines and snow stay crisp — the core "cinematic
// aerial" read.
//
// Importing this module applies the patch; it must be imported before the
// first render (engine imports it at module load).

// Fog thins with world height: exp(-y * HEIGHT_FALLOFF).
// 1/170 → peaks at y≈250 carry ~23% of floor-level haze.
const HEIGHT_FALLOFF = (1 / 170).toFixed(6);
// Distant haze shifts from the scene fog color toward this pale sky tint.
const FAR_TINT = "vec3(0.878, 0.845, 0.796)"; // 0xe0d8cb
const TINT_NEAR = "1100.0";
const TINT_FAR = "3200.0";

THREE.ShaderChunk["fog_pars_vertex"] = /* glsl */ `
#ifdef USE_FOG
  varying float vFogDepth;
  varying float vFogWorldY;
#endif
`;

THREE.ShaderChunk["fog_vertex"] = /* glsl */ `
#ifdef USE_FOG
  vFogDepth = - mvPosition.z;
  vec4 fogWorldPos = modelMatrix *
  #ifdef USE_INSTANCING
    instanceMatrix *
  #endif
    vec4( transformed, 1.0 );
  vFogWorldY = fogWorldPos.y;
#endif
`;

THREE.ShaderChunk["fog_pars_fragment"] = /* glsl */ `
#ifdef USE_FOG
  uniform vec3 fogColor;
  varying float vFogDepth;
  varying float vFogWorldY;
  #ifdef FOG_EXP2
    uniform float fogDensity;
  #else
    uniform float fogNear;
    uniform float fogFar;
  #endif
#endif
`;

THREE.ShaderChunk["fog_fragment"] = /* glsl */ `
#ifdef USE_FOG
  float hazeHeight = exp( - max( vFogWorldY, 0.0 ) * ${HEIGHT_FALLOFF} );
  #ifdef FOG_EXP2
    float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth * hazeHeight );
  #else
    float fogFactor = smoothstep( fogNear, fogFar, vFogDepth ) * hazeHeight;
  #endif
  vec3 hazeColor = mix( fogColor, ${FAR_TINT}, smoothstep( ${TINT_NEAR}, ${TINT_FAR}, vFogDepth ) );
  gl_FragColor.rgb = mix( gl_FragColor.rgb, hazeColor, clamp( fogFactor, 0.0, 1.0 ) );
#endif
`;

export const HAZE_PATCHED = true;
